import { BoxProps, ColorOptions } from '@jfs/ui-new'
import { isMobileWidth, isTabletWidth } from '../../../util/util'

export const styles = (breakpoint: number, responsivePadding: number) => {
  const isMobile = isMobileWidth(breakpoint)
  const isTab = isTabletWidth(breakpoint)
  return {
    outerontainer: {
      display: 'flex',
      flexDirection: 'column',
      overflow: 'scroll',
      bg: 'WHITE',
      margin: 0,
      padding: 0,
      h: 'calc(100vh - 72px)',
    } as BoxProps,
    container: {
      display: 'flex',
      flexWrap: 'wrap-reverse',
      position: 'relative',
      flexDirection: 'row',
      justifyContent: 'space-around',
      paddingHorizontal: responsivePadding,
      paddingTop: isTab || isMobile ? responsivePadding + 10 : 110,
      paddingBottom: isTab || isMobile ? 0 : 80,
      margin: 0,
    } as BoxProps,
    imageContainer: {
      display: 'flex',
      flex: 1,
      width: '50%',
      minHeight: 300,
      minWidth: 300,
      marginRight: isTab ? 12 : breakpoint > 600 ? -40 : 0,
      justifyContent: isTab ? 'flex-start' : breakpoint > 600 ? 'center' : 'center',
      alignItems: breakpoint > 600 ? 'flex-end' : 'center',
      marginTop: isTab ? 24 : breakpoint > 600 ? 0 : 0,
    } as BoxProps,
    leftBox: {
      display: 'flex',
      flex: 1,
      width: '50%',
      pt: isMobile ? 25 : undefined,
      minWidth: 300,
      minHeight: breakpoint > 600 ? '50vh' : '50vh',
      justifyContent: 'center',
    } as BoxProps,
    buttonContainer: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: breakpoint > 600 ? 'flex-start' : 'space-between',
      minHeight: isTab ? 60 : undefined,
    } as BoxProps,
    footerBackground: {
      paddingVertical: breakpoint > 600 ? 40 : 10,
      borderTopLeftRadius: breakpoint > 600 ? 120 : 24,
      bg: 'WHITE',
      mt: -120,
      borderTopRightRadius: breakpoint > 600 ? 120 : 24,
    } as BoxProps,
    formBox: {
      display: 'flex',
      flexDirection: isMobile ? 'column' : 'row',
      justifyContent: 'space-around',
      backgroundColor: '#24397A' as ColorOptions,
      paddingVertical: 200,
      marginBottom: -150,
      paddingTop: breakpoint > 600 ? 100 : 32,
      borderTopLeftRadius: breakpoint > 600 ? 120 : 24,
      borderTopRightRadius: breakpoint > 600 ? 120 : 24,
      paddingHorizontal: responsivePadding,
    } as BoxProps,
    borderBox: {
      borderRightWidth: 1,
      borderBottomWidth: 1,
      height: '98%',
      width: '100%',
      position: 'absolute',
      top: 28,
      left: isMobile ? 0 : 12,
      borderRightColor: 'BLUE',
      borderBottomColor: 'BLUE',
      borderRadius: 24,
    } as BoxProps,
  }
}
